import React, { JSX } from 'react';

import BuilderSection from '../layouts/BuilderSection';

interface TextHeroProps {
    content: string;
}

export default function TextHero({ content }: TextHeroProps): JSX.Element {
    return (
        <BuilderSection className="flex flex-col justify-center">
            <div
                className="flex-center-self w-full text-center text-gray-900 font-polysans text-3xl md:text-4xl"
                dangerouslySetInnerHTML={{ __html: content }}
            ></div>
        </BuilderSection>
    );
}
